import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 justify-start items-start" }
const _hoisted_2 = {
  class: "w-[315px] bg-white border border-[#E5E7EB] rounded-lg p-3 flex flex-col gap-2.5",
  style: {"font-family":"Inter, sans-serif"}
}
const _hoisted_3 = { class: "flex flex-col gap-3 w-full" }
const _hoisted_4 = { class: "flex flex-col gap-3 h-[68px]" }
const _hoisted_5 = { class: "flex justify-between items-start w-full" }
const _hoisted_6 = { class: "flex items-center gap-2.5" }
const _hoisted_7 = { class: "w-[32.46px] h-[32.46px] rounded-[15.57px] overflow-hidden flex-shrink-0" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "flex flex-col gap-0.5" }
const _hoisted_10 = { class: "flex items-center gap-1" }
const _hoisted_11 = { class: "text-[#2C2C2C] font-semibold text-[14px] leading-[1.67]" }
const _hoisted_12 = { class: "text-[#6B7280] font-normal text-[12px] leading-tight" }
const _hoisted_13 = { class: "flex items-center gap-[2.57px]" }
const _hoisted_14 = {
  key: 0,
  class: "relative flex flex-col rounded-md p-0.5 items-center bg-violet-100 group"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "flex justify-start w-full" }
const _hoisted_17 = { class: "flex items-center gap-[3.49px]" }
const _hoisted_18 = {
  key: 0,
  class: "relative w-[26px] h-[19px] bg-[#F6F8FA] rounded-[4.08px] flex justify-center items-center group"
}
const _hoisted_19 = { class: "absolute left-1/2 top-full mt-1 -ml-4 w-max max-w-xs px-2 py-1 text-xs text-white bg-gray-900 rounded-md opacity-0 group-hover:opacity-100 transition-opacity shadow-lg z-50 pointer-events-none -translate-x-1/2" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "text-[#2C2C2C] font-normal text-[10px] leading-tight text-center whitespace-nowrap" }
const _hoisted_22 = {
  key: 2,
  class: "relative w-[26px] h-[19px] bg-[#F6F8FA] rounded-[4.08px] flex justify-center items-center group"
}
const _hoisted_23 = { class: "flex flex-col gap-1.5 w-full mt-4" }
const _hoisted_24 = { class: "flex items-center gap-0.5 w-full" }
const _hoisted_25 = { class: "flex items-stretch gap-1 flex-1 h-2" }
const _hoisted_26 = { class: "flex items-center gap-0.5 w-full" }
const _hoisted_27 = { class: "flex items-stretch gap-1 flex-1 h-2" }
const _hoisted_28 = { class: "flex flex-wrap gap-2 mt-6" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "flex flex-wrap gap-2" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 0,
  class: "flex flex-row gap-2"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "text-gray-900/60 font-sans text-base font-bold leading-6" }
const _hoisted_35 = {
  key: 1,
  class: "flex flex-col gap-2 mt-4"
}
const _hoisted_36 = { class: "flex flex-row items-center gap-2" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "text-gray-900/60 font-sans text-base font-bold leading-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _ctx.expertProfilePicture,
                  alt: `${_ctx.expertName} Profile`,
                  class: "w-full h-full object-cover"
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.expertName), 1),
                  (_ctx.linkedinProfile)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLinkedInClick && _ctx.handleLinkedInClick(...args))),
                        class: "text-[#0076B2] w-[14px] h-[17px] flex-shrink-0 hover:opacity-80 transition-opacity cursor-pointer"
                      }, _cache[1] || (_cache[1] = [
                        _createElementVNode("svg", {
                          width: "14",
                          height: "17",
                          viewBox: "0 0 24 24",
                          fill: "currentColor",
                          class: "w-full h-full"
                        }, [
                          _createElementVNode("path", { d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" })
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.expertTitle), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.anyPastMeetings)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", { innerHTML: _ctx.FIRE_ICON }, null, 8, _hoisted_15),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute left-1/2 -translate-x-[80%] top-full mt-2 -ml-4 w-max max-w-xs px-2 py-1 text-xs text-white bg-gray-900 rounded-md opacity-0 group-hover:opacity-100 transition-opacity shadow-lg z-50 pointer-events-none" }, " Recent Meetings ", -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (_ctx.getCountryCode(_ctx.expertCountry))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("span", {
                      class: _normalizeClass([`fi fi-${_ctx.getCountryCodeForFlagIcon(_ctx.expertCountry)}`, "text-sm"])
                    }, null, 2),
                    _createElementVNode("div", _hoisted_19, " Location: " + _toDisplayString(_ctx.expertCountry), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.spokenLanguages.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.spokenLanguages.slice(0, 2), (language, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `lang-${index}`,
                      class: "bg-[#F6F8FA] rounded-[4.08px] flex justify-center items-center px-2 py-1",
                      title: language
                    }, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(language), 1)
                    ], 8, _hoisted_20))
                  }), 128))
                : _createCommentVNode("", true),
              (!_ctx.getCountryCode(_ctx.expertCountry))
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[3] || (_cache[3] = [
                    _createElementVNode("span", { class: "fi fi-us text-sm" }, null, -1),
                    _createElementVNode("div", { class: "absolute left-1/2 top-full mt-1 -ml-4 w-max max-w-xs px-2 py-1 text-xs text-white bg-gray-900 rounded-md opacity-0 group-hover:opacity-100 transition-opacity shadow-lg z-50 pointer-events-none -translate-x-1/2" }, " Location: United States ", -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-black font-normal text-xs leading-tight w-[76px] flex-shrink-0" }, " Expertise ", -1)),
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                return _createElementVNode("div", {
                  key: `expertise-${i}`,
                  class: _normalizeClass(["flex-1 rounded-sm", i <= _ctx.expertiseLevel ? 'bg-[#6A48F3]' : 'bg-[#C7D3EB]'])
                }, null, 2)
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-black font-normal text-xs leading-tight w-[76px] flex-shrink-0" }, " Experience ", -1)),
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                return _createElementVNode("div", {
                  key: `experience-${i}`,
                  class: _normalizeClass(["flex-1 rounded-sm", i <= _ctx.experienceLevel ? 'bg-[#6A48F3]' : 'bg-[#C7D3EB]'])
                }, null, 2)
              }), 64))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", { innerHTML: _ctx.CLOCK_ICON }, null, 8, _hoisted_29),
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-gray-900/60 font-sans text-base font-bold leading-6" }, "30 min", -1))
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", { innerHTML: _ctx.PHONE_ICON }, null, 8, _hoisted_31),
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-gray-900/60 font-sans text-base font-bold leading-6" }, "Phone call", -1))
    ]),
    (_ctx.hasDateAndTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", { innerHTML: _ctx.CALENDAR_ICON }, null, 8, _hoisted_33),
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.dateAndTime), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.previousMeeting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-primary-purple bg-primary-purple/10 px-2 py-1 rounded-md font-sans text-base font-bold leading-6" }, "Previous booking:", -1)),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", { innerHTML: _ctx.CALENDAR_ICON }, null, 8, _hoisted_37),
            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.previousMeeting), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}